export default "__VITE_ASSET__DXxTIVAS__"